import type { SVGProps } from 'react';
const SvgEmojiTransportation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#emoji_transportation_svg__a)">
      <path d="M20.57 10.66c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66L10 14.77l.01 5.51c0 .38.31.72.69.72h.62c.38 0 .68-.38.68-.76V19h8v1.24c0 .38.31.76.69.76h.61c.38 0 .69-.34.69-.72l.01-1.37v-4.14l-1.43-4.11Zm-8.16.34h7.19l1.03 3h-9.25l1.03-3ZM12 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Z" />
      <path d="M14 9h1V3H7v5H2v13h1V9h5V4h6v5Z" />
      <path d="M7 11H5v2h2v-2ZM12 5h-2v2h2V5ZM7 15H5v2h2v-2ZM7 19H5v2h2v-2Z" />
    </g>
    <defs>
      <clipPath id="emoji_transportation_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEmojiTransportation;
